import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import { Col, Container, Row } from "react-bootstrap";
import { constructionType, farLandUseTypes, landSubUseTypes, landUseList, schemesData, yesNoRadioList } from "../../../../TCPForms/data";
import ButtonWrapper from "../../../components/Button";

const SubStep3 = ({ formData, handleSubTabChange, t, applicationFlow, isAssignedLTP, applicationData, pFarList, isApproved, isEmployee }) => {
  const approvedLayout = applicationData?.descriptionOfLand?.schemeType === "Scheme" ? true : false;
  const defaultValues = {
    ...formData,
    approvedLayout: approvedLayout ? "Yes" : "No",
  };

  const { handleSubmit, control, reset, watch, setValue, getValues } = useForm({ defaultValues });
  const approveLayout = watch("approvedLayout");
  console.log("applicationDataFrom2", applicationData, pFarList);
  const maxRoadWidth = Math.max(...(applicationData?.descriptionOfLand?.roadWidths?.map((item) => item.value) || []));
  const maxApproachWidth = Math.max(...(applicationData?.descriptionOfLand?.approachRoadWidths?.map((item) => item.value) || []));
  console.log("maxRoadWidth", maxRoadWidth, maxApproachWidth);
  const checkFAR = (landUse, landSubUse, masterData, isSchemeType) => {
    const result = isSchemeType
      ? false
      : masterData
          ?.filter((item) => item.category === landUse)?.[0]
          ?.ProposedActivity?.filter((item) => item.BasicFAR == "")
          ?.filter((item) => item.ActivityProposed === landSubUse);
    console.log("resultBasicFAR", result);
    if (isSchemeType) {
      return false;
    }
    // return result?.length > 0 ? false : true;
    return !(result?.length === 0);
  };
  const isBasicFAR = checkFAR(
    applicationData?.descriptionOfLand?.landUsesType,
    applicationData?.descriptionOfLand?.subLandUseAsPerLayout,
    pFarList,
    approvedLayout
  );
  console.log("isBasicFAR", isBasicFAR);

  useEffect(() => {
    const newProperties = [
      {
        ...formData?.descriptionOfLand?.properties?.[0],
        landArea: applicationData?.descriptionOfLand?.landArea,
        propertyNo: applicationData?.descriptionOfLand?.plotNo,
        khatauniNo: applicationData?.descriptionOfLand?.khatauniNo,
        plotNo: applicationData?.descriptionOfLand?.plotNo,
        khataNo: applicationData?.descriptionOfLand?.khataNo,
        plotWidth: applicationData?.descriptionOfLand?.landWidth,
        roadWidth: maxRoadWidth,
        approachRoadWidth: maxApproachWidth,
        khasraNo: applicationData?.descriptionOfLand?.khasraWithArea?.[0]?.khasraNo,
        landUseAsPerLayout: applicationData?.descriptionOfLand?.landUsesType,
        subLandUseAsPerLayout: applicationData?.descriptionOfLand?.subLandUseAsPerLayout,
        schemeName: applicationData?.descriptionOfLand?.schemeName,
        plotNo: applicationData?.descriptionOfLand?.plotNo,
        sectorNo: applicationData?.descriptionOfLand?.sectorNo,
        landLength: applicationData?.descriptionOfLand?.landLength,
        landAddress: applicationData?.descriptionOfLand?.landAddress,
        landMark: applicationData?.descriptionOfLand?.landMark,
        selectLandUse: applicationData?.descriptionOfLand?.selectLandUse,
        proposedActivity: applicationData?.descriptionOfLand?.proposedActivity,
      },
    ];
    reset({
      ...formData,
      approvedLayout: applicationData?.descriptionOfLand?.schemeType,
      descriptionOfLand: {
        ...formData?.descriptionOfLand,
        properties: [{ ...newProperties[0] }],
      },
    });
  }, [approveLayout]);
  const onSubmit = (data) => {
    // if (data.taxHeadEstimates && data.taxHeadEstimates[0]) {
    //   const basicFar = data.taxHeadEstimates[0].basicFar;

    //   // Ensure basicFar is a valid number or set it to 0 (or another default value)
    //   const updatedBasicFar = basicFar ? parseFloat(basicFar) : 0;

    //   // Update the data with the numeric value
    //   data.taxHeadEstimates[0].basicFar = updatedBasicFar;
    // }
    console.log("fromSub2", data);
    handleSubTabChange(3, data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Layout Details")}</h2>
          </div>
          <Container className="formInputContainer" fluid>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Scheme Type")}
                  // defaultValue={formData?.approvedLayout}
                  name="approvedLayout"
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select any value.",
                    },
                  }}
                  isApproved={true}
                  disabled={
                    Boolean(isAssignedLTP) ||
                    Boolean(formData?.approvedLayout) ||
                    Boolean(applicationData?.descriptionOfLand?.schemeType) ||
                    isEmployee ||
                    isApproved
                  } // Add disabled here
                />
              </Col>
              {approveLayout === "Scheme" ? (
                <Col>
                  <InputWrapper
                    control={control}
                    label="Scheme Name"
                    placeholder="Enter Scheme Name"
                    name={`descriptionOfLand.properties[0].schemeName`}
                    type="textInput"
                    maxLength={30}
                    defaultValue={formData?.descriptionOfLand?.schemeName}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    isApproved={true}
                    disabled={
                      Boolean(isAssignedLTP) ||
                      Boolean(formData?.descriptionOfLand?.properties[0]?.schemeName) ||
                      Boolean(applicationData?.descriptionOfLand?.schemeName) ||
                      isEmployee ||
                      isApproved
                    }
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {approveLayout === "Scheme" && (
              <React.Fragment>
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Plot No."}
                      placeholder="Enter Plot Number"
                      maxLength={10}
                      mandatory={approveLayout === "Scheme"}
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isRequired={true}
                      name="descriptionOfLand.properties[0].plotNo"
                      type="number"
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.plotNo) ||
                        Boolean(applicationData?.descriptionOfLand?.plotNo) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={"Sector No."}
                      control={control}
                      placeholder="Enter Sector Number"
                      name="descriptionOfLand.properties[0].sectorNo"
                      type="number"
                      maxLength={10}
                      mandatory={approveLayout === "Scheme"}
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.sectorNo) ||
                        Boolean(applicationData?.descriptionOfLand?.sectorNo) ||
                        isEmployee ||
                        isApproved
                      }
                      isRequired={approveLayout === "Scheme"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Land Use as per Approved Layout Plan")}
                      control={control}
                      placeholder={t("Enter Land Use Details")}
                      name="descriptionOfLand.properties[0].landUseAsPerLayout"
                      type="selectInput"
                      data={farLandUseTypes}
                      mandatory
                      maxLength={150}
                      multiLine
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landUseAsPerLayout) ||
                        Boolean(applicationData?.descriptionOfLand?.landUsesType) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("Land Sub Use as per Layout")}
                      control={control}
                      placeholder={t("LABEL_SELECT_LAND_SUB_USE_TYPE")}
                      name="descriptionOfLand.properties[0].subLandUseAsPerLayout"
                      type="selectInput"
                      data={landSubUseTypes}
                      mandatory
                      maxLength={150}
                      multiLine
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.subLandUseAsPerLayout) ||
                        Boolean(applicationData?.descriptionOfLand?.subLandUseAsPerLayout) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  {applicationData?.descriptionOfLand?.khasraWithArea?.[0]?.khasraNo && (
                    <Col>
                      <InputWrapper
                        control={control}
                        label={t("LABEL_KHASRA_NO")}
                        placeholder={t("LABEL_ENTER_KHASRA_NO")}
                        name="descriptionOfLand.properties[0].khasraNo"
                        type="textInput"
                        isApproved={true}
                        // defaultValue={descriptionOfLand?.khasraNo}
                        disabled={
                          Boolean(isAssignedLTP) ||
                          Boolean(formData?.descriptionOfLand?.properties[0]?.khasraNo) ||
                          Boolean(applicationData?.descriptionOfLand?.khasraWithArea?.[0]?.khasraNo) ||
                          isEmployee ||
                          isApproved
                        } // Add disabled here
                      />
                    </Col>
                  )}
                  {applicationData?.descriptionOfLand?.khataNo && (
                    <Col>
                      <InputWrapper
                        label={t("LABEL_KHATA_NO")}
                        control={control}
                        placeholder={t("LABEL_ENTER_KHATA_NO")}
                        name="descriptionOfLand.properties[0].khataNo"
                        type="textInput"
                        isApproved={true}
                        // defaultValue={descriptionOfLand?.khataNo}
                        disabled={
                          Boolean(isAssignedLTP) ||
                          Boolean(formData?.descriptionOfLand?.properties[0]?.khataNo) ||
                          Boolean(applicationData?.descriptionOfLand?.khataNo) ||
                          isEmployee ||
                          isApproved
                        } // Add disabled here
                      />
                    </Col>
                  )}
                </Row>
                {/* <Row>
                  <Col>
                    <InputWrapper
                      label="Plot Depth"
                      control={control}
                      placeholder="Enter Plot Depth"
                      // defaultValue={formData?.descriptionOfLand?.landLength}
                      name="descriptionOfLand.properties[0].landLength"
                      type="number"
                      maxLength={10}
                      mandatory={true}
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isRequired={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landLength) ||
                        Boolean(applicationData?.descriptionOfLand?.landLength)
                      } //
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("Plot Width")}
                      control={control}
                      placeholder={t("LABEL_ENTER_LAND_WIDTH")}
                      name="descriptionOfLand.properties[0].plotWidth"
                      type="textInput"
                      maxLength={10}
                      mandatory
                      required
                      // defaultValue={descriptionOfLand?.plotWidth}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.plotWidth) ||
                        Boolean(applicationData?.descriptionOfLand?.landWidth)
                      } // Add disabled here
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Plot Area (in Sq. M)"
                      placeholder="Enter Plot Area"
                      // defaultValue={formData?.descriptionOfLand?.landArea}
                      // value={totalPlotAreaVal}
                      name="descriptionOfLand.properties[0].landArea"
                      type="number"
                      mandatory
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landArea) ||
                        Boolean(applicationData?.descriptionOfLand?.landArea) ||
                        isEmployee ||
                        isApproved
                      }
                      isRequired={true}
                      maxLength={6}
                    />
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Existing Road Width"
                      placeholder="Enter Road Width"
                      name={`descriptionOfLand.properties[0].roadWidth`}
                      type="number"
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={2}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.roadWidth) ||
                        Boolean(maxRoadWidth) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Approach Road Width (as per the actual plan)"
                      placeholder="Enter Road Width"
                      name={`descriptionOfLand.properties[0].approachRoadWidth`}
                      type="number"
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={2}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.approachRoadWidth) ||
                        Boolean(maxApproachWidth) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      label="Near by Landmark"
                      control={control}
                      placeholder="Enter Near by Landmark"
                      name="descriptionOfLand.properties[0].landMark"
                      type="textInput"
                      mandatory
                      required
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landMark) ||
                        Boolean(applicationData?.descriptionOfLand?.landMark) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label="Land Address"
                      control={control}
                      placeholder="Enter Land Address"
                      name="descriptionOfLand.properties[0].landAddress"
                      type="textInput"
                      mandatory
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landAddress) ||
                        Boolean(applicationData?.descriptionOfLand?.landAddress) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}

            {approveLayout != "Scheme" && (
              <React.Fragment>
                {applicationData?.descriptionOfLand?.plotNo && (
                  <Row>
                    <Col>
                      <InputWrapper
                        control={control}
                        label={"Plot/House No."}
                        placeholder="Enter Plot Number"
                        maxLength={10}
                        mandatory={approveLayout === "Scheme"}
                        validation={{
                          required: {
                            message: "This field is required",
                          },
                        }}
                        isRequired={true}
                        name="descriptionOfLand.properties[0].plotNo"
                        type="number"
                        isApproved={true}
                        disabled={
                          Boolean(isAssignedLTP) ||
                          Boolean(formData?.descriptionOfLand?.properties[0]?.plotNo) ||
                          Boolean(applicationData?.descriptionOfLand?.plotNo) ||
                          isEmployee ||
                          isApproved
                        }
                      />
                    </Col>
                    <Col></Col>
                  </Row>
                )}
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Land Use as per Master Plan")}
                      control={control}
                      placeholder={t("Enter Land Use Details")}
                      name="descriptionOfLand.properties[0].landUseAsPerLayout"
                      type="selectInput"
                      data={farLandUseTypes}
                      mandatory
                      maxLength={150}
                      multiLine
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landUseAsPerLayout) ||
                        Boolean(applicationData?.descriptionOfLand?.landUsesType) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("Proposed Activity")}
                      control={control}
                      placeholder={t("LABEL_SELECT_LAND_SUB_USE_TYPE")}
                      name="descriptionOfLand.properties[0].subLandUseAsPerLayout"
                      type="selectInput"
                      data={landSubUseTypes}
                      mandatory
                      maxLength={150}
                      multiLine
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.subLandUseAsPerLayout) ||
                        Boolean(applicationData?.descriptionOfLand?.subLandUseAsPerLayout) ||
                        isEmployee ||
                        isApproved
                      } // Add disabled here
                    />
                  </Col>
                </Row>
                <Row>
                  {applicationData?.descriptionOfLand?.selectLandUse ? (
                    <Col>
                      <InputWrapper
                        control={control}
                        label="Permissibility of Activities"
                        inputLabel="Select activities."
                        placeholder="Select activities."
                        name="descriptionOfLand.properties[0].selectLandUse"
                        type="selectInput"
                        // defaultValue={formData?.descriptionOfLand?.selectLandUse}
                        data={landUseList}
                        isApproved={true}
                        disabled={
                          Boolean(isAssignedLTP) ||
                          Boolean(formData?.descriptionOfLand?.properties[0]?.selectLandUse) ||
                          Boolean(applicationData?.descriptionOfLand?.selectLandUse) ||
                          isEmployee ||
                          isApproved
                        }
                      />
                    </Col>
                  ) : (
                    <Col></Col>
                  )}
                  {applicationData?.descriptionOfLand?.proposedActivity ? (
                    <Col>
                      <InputWrapper
                        control={control}
                        label="Proposed Activity as per Zoning Regulation"
                        placeholder="Enter activity"
                        name={`descriptionOfLand.properties[0].proposedActivity`}
                        type="textInput"
                        maxLength={30}
                        isApproved={true}
                        disabled={
                          Boolean(isAssignedLTP) ||
                          Boolean(formData?.descriptionOfLand?.properties[0]?.proposedActivity) ||
                          Boolean(applicationData?.descriptionOfLand?.proposedActivity) ||
                          isEmployee ||
                          isApproved
                        }
                      />
                    </Col>
                  ) : (
                    <Col></Col>
                  )}
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("LABEL_KHASRA_NO")}
                      placeholder={t("LABEL_ENTER_KHASRA_NO")}
                      name="descriptionOfLand.properties[0].khasraNo"
                      type="textInput"
                      isApproved={true}
                      // defaultValue={descriptionOfLand?.khasraNo}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.khasraNo) ||
                        Boolean(applicationData?.descriptionOfLand?.khasraWithArea?.[0]?.khasraNo) ||
                        isEmployee ||
                        isApproved
                      } // Add disabled here
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("LABEL_KHATA_NO")}
                      control={control}
                      placeholder={t("LABEL_ENTER_KHATA_NO")}
                      name="descriptionOfLand.properties[0].khataNo"
                      type="textInput"
                      isApproved={true}
                      // defaultValue={descriptionOfLand?.khataNo}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.khataNo) ||
                        Boolean(applicationData?.descriptionOfLand?.khataNo) ||
                        isEmployee ||
                        isApproved
                      } // Add disabled here
                    />
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <InputWrapper
                      label="Plot Depth"
                      control={control}
                      placeholder="Enter Plot Depth"
                      // defaultValue={formData?.descriptionOfLand?.landLength}
                      name="descriptionOfLand.properties[0].landLength"
                      type="number"
                      maxLength={10}
                      mandatory={true}
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isRequired={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landLength) ||
                        Boolean(applicationData?.descriptionOfLand?.landLength)
                      } //
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("Plot Width")}
                      control={control}
                      placeholder={t("LABEL_ENTER_LAND_WIDTH")}
                      name="descriptionOfLand.properties[0].plotWidth"
                      type="textInput"
                      maxLength={10}
                      mandatory
                      required
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.plotWidth) ||
                        Boolean(applicationData?.descriptionOfLand?.landWidth)
                      } // Add disabled here
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Land Area (in Sq. M)"
                      placeholder="Enter Land Area"
                      // defaultValue={formData?.descriptionOfLand?.landArea}
                      // value={totalPlotAreaVal}
                      name="descriptionOfLand.properties[0].landArea"
                      type="number"
                      mandatory
                      validation={{
                        required: {
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landArea) ||
                        Boolean(applicationData?.descriptionOfLand?.landArea) ||
                        isEmployee ||
                        isApproved
                      }
                      isRequired={true}
                      maxLength={6}
                    />
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Existing Road Width"
                      placeholder="Enter Road Width"
                      name={`descriptionOfLand.properties[0].roadWidth`}
                      type="number"
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={2}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.roadWidth) ||
                        Boolean(maxRoadWidth) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label="Approach Road Width (as per the actual plan)"
                      placeholder="Enter Road Width"
                      name={`descriptionOfLand.properties[0].approachRoadWidth`}
                      type="number"
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={2}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.approachRoadWidth) ||
                        Boolean(maxApproachWidth) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      label="Near by Landmark"
                      control={control}
                      placeholder="Enter Near by Landmark"
                      name="descriptionOfLand.properties[0].landMark"
                      type="textInput"
                      mandatory
                      required
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landMark) ||
                        Boolean(applicationData?.descriptionOfLand?.landMark) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label="Land Address"
                      control={control}
                      placeholder="Enter Land Address"
                      name="descriptionOfLand.properties[0].landAddress"
                      type="textInput"
                      mandatory
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      isApproved={true}
                      disabled={
                        Boolean(isAssignedLTP) ||
                        Boolean(formData?.descriptionOfLand?.properties[0]?.landAddress) ||
                        Boolean(applicationData?.descriptionOfLand?.landAddress) ||
                        isEmployee ||
                        isApproved
                      }
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row>
              {approveLayout != "Scheme" ? (
                <React.Fragment>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Development Zone")}
                      placeholder={t("Select development zone")}
                      // defaultValue={descriptionOfLand?.constructionType}
                      name="descriptionOfLand.properties[0].constructionType"
                      type="selectInput"
                      data={constructionType}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "Please select any value",
                        },
                      }}
                      isApproved={true}
                      disabled={Boolean(isAssignedLTP) || isEmployee || isApproved} // Add disabled here
                    />
                  </Col>
                  <Col></Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Development Zone")}
                      placeholder={t("Select development zone")}
                      // defaultValue={descriptionOfLand?.constructionType}
                      name="descriptionOfLand.properties[0].constructionType"
                      type="selectInput"
                      data={constructionType}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "Please select any value",
                        },
                      }}
                      isApproved={true}
                      disabled={Boolean(isAssignedLTP) || isEmployee || isApproved} // Add disabled here
                    />
                  </Col>
                  <Col></Col>
                </React.Fragment>
              )}
            </Row>
            {!isBasicFAR && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Basic FAR")}
                    control={control}
                    placeholder={t("Enter Basic FAR")}
                    name="descriptionOfLand.properties[0].baseFAR"
                    type="decimal"
                    maxLength={10}
                    mandatory
                    required
                    // defaultValue={descriptionOfLand?.plotWidth}
                    disabled={
                      Boolean(isAssignedLTP) ||
                      Boolean(formData?.descriptionOfLand?.properties[0]?.plotWidth) ||
                      Boolean(applicationData?.descriptionOfLand?.landWidth) ||
                      isEmployee ||
                      isApproved
                    } // Add disabled here
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
          </Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(1)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep3;
